import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasHeaderComponent } from './gas-header.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasBreadcrumbsModule } from '../../common/gas-breadcrumbs/gas-breadcrumbs.module';
import { GasTemplateModule } from '../../utils/gas-template/gas-template.module';
import { GasButtonModule } from '../../forms/gas-button/gas-button.module';
import { GasPopupModule } from '../../common/gas-popup/gas-popup.module';

const COMPONENTS = [
  GasHeaderComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasBreadcrumbsModule,
    GasTemplateModule,
    GasButtonModule,
    GasPopupModule,
  ],
})
export class GasHeaderModule { }
